import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-134f5d6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "public-profile"
}
const _hoisted_2 = { class: "card main-profile-card mt-5" }
const _hoisted_3 = { class: "main-profile-inner" }
const _hoisted_4 = { class: "main-profile-left" }
const _hoisted_5 = { class: "avatar-wrap" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-dot" }, null, -1))
const _hoisted_8 = { class: "identity" }
const _hoisted_9 = { class: "identity-name-row" }
const _hoisted_10 = { class: "identity-name" }
const _hoisted_11 = {
  key: 0,
  src: "/favicon.png",
  alt: "Elite Member",
  title: "Elite Member",
  class: "elite-icon"
}
const _hoisted_12 = {
  key: 0,
  class: "identity-role"
}
const _hoisted_13 = {
  key: 1,
  class: "identity-location"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt-fill" }, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "specialty-tags"
}
const _hoisted_16 = { class: "identity-bio" }
const _hoisted_17 = { class: "social-row" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-github" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-linkedin" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "main-profile-right" }
const _hoisted_25 = { class: "patent-summary" }
const _hoisted_26 = { class: "patent-icon-frame" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "patent-summary-text" }
const _hoisted_29 = { class: "patent-name" }
const _hoisted_30 = { class: "patent-xp" }
const _hoisted_31 = {
  key: 0,
  class: "patent-global-rank"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trophy-fill" }, null, -1))
const _hoisted_33 = {
  key: 0,
  class: "next-patent"
}
const _hoisted_34 = { class: "next-patent-header" }
const _hoisted_35 = { class: "next-patent-percent" }
const _hoisted_36 = { class: "next-patent-caption" }
const _hoisted_37 = { class: "profile-layout mt-6" }
const _hoisted_38 = { class: "card card-flush" }
const _hoisted_39 = { class: "px-7 pt-5 pb-1 d-row d-flex justify-content-between align-items-center border-bottom" }
const _hoisted_40 = { class: "card-title d-flex align-items-start flex-column mb-0" }
const _hoisted_41 = { class: "card-label fw-bolder" }
const _hoisted_42 = {
  key: 0,
  class: "badges-grid-scroll py-4 px-4",
  role: "region",
  "aria-label": "Badges"
}
const _hoisted_43 = {
  key: 1,
  class: "badges-grid-empty py-5"
}
const _hoisted_44 = { class: "text-gray-600 fw-bold fs-5 text-center px-6" }
const _hoisted_45 = { class: "card card-flush" }
const _hoisted_46 = { class: "px-7 pt-5 pb-1 d-row border-bottom" }
const _hoisted_47 = { class: "card-title d-flex align-items-start flex-column" }
const _hoisted_48 = { class: "card-label fw-bolder" }
const _hoisted_49 = { class: "carousel__item" }
const _hoisted_50 = { class: "card" }
const _hoisted_51 = { class: "card-body" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fs-3 mb-0" }, "Habilidades")
], -1))
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  class: "d-flex justify-content-center",
  style: {"height":"1024px"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner spinner-primary spinner-lg mr-15" }, null, -1))
const _hoisted_56 = { class: "fs-4 text-gray-700 mt-10" }

import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { computed, ref, onBeforeMount, watch, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/core/services/ApiService";
import { useI18n } from 'vue-i18n';
import axios, { CancelToken } from "axios";
import CourseCertificateHexagon from "@/modern/components/profile/CourseCertificateHexagon.vue";
import CardBadge from "@/components/badge/CardBadge.vue";
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Navigation, Slide } from 'vue3-carousel'
import AbilitiesRadarGraphic from "@/modern/components/ui/AbilitiesRadarGraphic.vue";
import ProgressBar from "@/modern/components/ui/ProgressBar.vue";
import CertificationsBadgeRow from "@/modern/components/profile/CertificationsBadgeRow.vue";
import ProfileStatsList from "@/modern/components/profile/ProfileStatsList.vue";
import ActivityHeatmap from "@/modern/components/profile/ActivityHeatmap.vue";
import RecentActivityList from "@/modern/components/profile/RecentActivityList.vue";
import { usePatentSystem } from "@/modern/composables/usePatentSystem";
import type { ModernCategory } from "@/modern/types/dashboard";



export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const { t } = useI18n();
const store = useStore();
const $route = useRoute();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const userPublic = computed(() => store.getters.publicUser || {});

const certificates = computed(() => userPublic.value.certificates);
const certifications = computed(() => userPublic.value?.certifications || []);

// Some accounts already store the full profile URL in github_url/linkedin_url
// instead of just the username — prepending the base URL again would double it up.
const socialLink = (base: string, value: string) => (/^https?:\/\//i.test(value) ? value : base + value);

const specialtyTags = computed(() => {
  const tags = userPublic.value?.tags_owned || [];
  return tags
    .filter((tag: any) => Number(tag?.owned) > 0)
    .map((tag: any) => tag.name)
    .slice(0, 3);
});

const ownedBadges = computed(() => {
  const allBadges = userPublic.value?.badges || [];
  const userId = userPublic.value?.id;

  const hasOwnershipMarkers = allBadges.some(
    (b: any) => "user_id" in b || "badge_id" in b || "owned" in b || "has_badge" in b
  );

  // If the API already returns only owned badges, keep as-is.
  if (!hasOwnershipMarkers) return allBadges;

  // Otherwise, keep only owned ones.
  return allBadges.filter((b: any) => {
    if (userId && b?.user_id) return b.user_id === userId;
    return Boolean(b?.badge_id ?? b?.owned ?? b?.has_badge);
  });
});

const loading = ref(false);
const radarFiltering = ref(false);
const radarCategories = ref<ModernCategory[]>([]);
const radarAllCategories = ref<ModernCategory[]>([]);
const radarSelectedCategoryIds = ref<number[]>([]);
const totalMachines = ref(0);
const totalChallenges = ref(0);
const radarFilterCancelSource = ref<ReturnType<typeof axios.CancelToken.source> | null>(null);

const scoreValue = computed(() => Number(userPublic.value?.score?.value || 0));
const { patent: userPatent, nextPatent, xpToNextPatent, progressToNextPatent } = usePatentSystem(scoreValue, currentLanguage, t);

const normalizePublicUserData = () => {
  const tagsOwned = store.getters.publicUser?.tags_owned;
  if (!Array.isArray(tagsOwned)) {
    return;
  }

  tagsOwned.forEach((tag: any, index: number) => {
    if (tag?.owned > tag?.total) {
      store.getters.publicUser.tags_owned[index].owned = tag.total;
    }
  });
};

const normalizeRadarCategory = (category: any): ModernCategory => ({
  id: Number(category?.id ?? category?.category_id ?? 0),
  name: String(category?.name ?? ""),
  percentage: String(category?.percentage ?? category?.value ?? 0),
});

const mapRadarCategories = (categories: unknown): ModernCategory[] => {
  if (!Array.isArray(categories)) {
    return [];
  }

  return categories
    .map((category) => normalizeRadarCategory(category))
    .filter((category) => Number.isFinite(category.id) && category.id > 0 && category.name.length > 0);
};

const syncRadarDataFromPublicUser = () => {
  const owned = mapRadarCategories(userPublic.value?.categories_owned);
  radarCategories.value = owned;
  radarSelectedCategoryIds.value = owned.map((category) => category.id);

  const all = mapRadarCategories(userPublic.value?.tag_categories);
  radarAllCategories.value = all.map((category) => ({ ...category, percentage: "0" }));
};

const fetchPublicOwnedCategoriesWithTimeout = async (
  ids: number[],
  timeoutMs = 15000,
  cancelToken?: CancelToken
) => {
  const params = new URLSearchParams();
  ids.forEach((id) => params.append("categories[]", String(id)));

  let timeoutHandle: ReturnType<typeof setTimeout> | null = null;

  const timeoutPromise = new Promise<ModernCategory[]>((_, reject) => {
    timeoutHandle = setTimeout(() => reject(new Error("Filter request timeout")), timeoutMs);
  });

  try {
    return await Promise.race<ModernCategory[]>([
      ApiService.query(
        `/public/profile/${$route.params.id}?${params.toString()}`,
        cancelToken ? { cancelToken } : {}
      ).then(
        (response) => {
          const raw = response?.data?.data?.categories_owned;
          return mapRadarCategories(raw);
        }
      ),
      timeoutPromise,
    ]);
  } finally {
    if (timeoutHandle) {
      clearTimeout(timeoutHandle);
    }
  }
};

const handlePublicRadarApplyFilter = async () => {
  if (radarSelectedCategoryIds.value.length !== 5) {
    return;
  }

  radarFilterCancelSource.value?.cancel("Superseded radar filter request");
  const cancelSource = axios.CancelToken.source();
  radarFilterCancelSource.value = cancelSource;

  radarFiltering.value = true;
  try {
    const filteredCategories = await fetchPublicOwnedCategoriesWithTimeout(
      radarSelectedCategoryIds.value,
      15000,
      cancelSource.token
    );
    if (radarFilterCancelSource.value === cancelSource) {
      radarCategories.value = filteredCategories;
    }
  } catch (error) {
    if (!axios.isCancel(error) && radarFilterCancelSource.value === cancelSource) {
      console.error("Error filtering public categories:", error);
    }
  } finally {
    if (radarFilterCancelSource.value === cancelSource) {
      radarFiltering.value = false;
      radarFilterCancelSource.value = null;
    }
  }
};

const loadPublicUser = async (id: string | string[] | undefined) => {
  const routeId = Array.isArray(id) ? id[0] : id;
  try {
    loading.value = true;
    await store.dispatch(Actions.GET_PUBLIC_USER, { id: routeId });
    normalizePublicUserData();
    syncRadarDataFromPublicUser();
    if (store.getters.publicUser) {
      totalMachines.value = store.getters.publicUser?.total_machines || 0;
      totalChallenges.value = store.getters.publicUser?.total_challenges || 0;
    } else {
      totalMachines.value = 0;
      totalChallenges.value = 0;
    }
  } catch (e) {
    console.log(e);
  } finally {
    loading.value = false;
  }
};

onBeforeMount(async () => {
  await loadPublicUser($route.params.id);
});

onBeforeUnmount(() => {
  radarFilterCancelSource.value?.cancel("User profile view unmounted");
  radarFilterCancelSource.value = null;
});

watch(
  () => [userPublic.value?.categories_owned, userPublic.value?.tag_categories],
  () => {
    syncRadarDataFromPublicUser();
  }
);

watch(
  () => $route.params.id,
  async (newId, oldId) => {
    if (newId !== oldId) {
      await loadPublicUser(newId);
    }
  }
);


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _unref(userPublic).avatar,
                  class: "avatar-image",
                  alt: ""
                }, null, 8, _hoisted_6),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(userPublic).nick || 'No nick'), 1),
                  (_unref(userPublic).is_elite)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                    : _createCommentVNode("", true)
                ]),
                (_unref(userPublic).role)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(userPublic).role), 1))
                  : _createCommentVNode("", true),
                (_unref(userPublic).country)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(_unref(userPublic).country), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(specialtyTags).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specialtyTags), (tag) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: tag,
                          class: "specialty-tag"
                        }, _toDisplayString(tag), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(userPublic).bio || 'No bio'), 1),
                _createElementVNode("div", _hoisted_17, [
                  (_unref(userPublic)?.github_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: socialLink('https://github.com/', _unref(userPublic)?.github_url),
                        target: "_blank",
                        "aria-label": "GitHub"
                      }, _hoisted_20, 8, _hoisted_18))
                    : _createCommentVNode("", true),
                  (_unref(userPublic)?.linkedin_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: socialLink('https://www.linkedin.com/in/', _unref(userPublic)?.linkedin_url),
                        target: "_blank",
                        "aria-label": "LinkedIn"
                      }, _hoisted_23, 8, _hoisted_21))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: '/media/logos/badges/' + _unref(userPatent)?.icon,
                    class: "patent-icon",
                    alt: ""
                  }, null, 8, _hoisted_27)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(userPatent)?.name), 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString((_unref(userPublic)?.score?.value || 0).toLocaleString()) + " XP", 1),
                  (_unref(userPublic).scoreboard_global_position)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.top_global`, { n: _unref(userPublic).scoreboard_global_position })), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_unref(nextPatent))
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.next_patent`)) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_unref(nextPatent).name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(Math.round(_unref(progressToNextPatent))) + "%", 1)
                    ]),
                    _createVNode(ProgressBar, {
                      value: _unref(progressToNextPatent),
                      max: 100
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.missing_xp`, { n: _unref(xpToNextPatent).toLocaleString() })), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode(ProfileStatsList, {
          class: "mt-6",
          "scoreboard-position": _unref(userPublic).scoreboard_position,
          "scoreboard-global-position": _unref(userPublic).scoreboard_global_position ?? null,
          "total-first-bloods": _unref(userPublic).total_first_bloods || 0,
          "machines-completed": _unref(userPublic).machines_completed || 0,
          "total-machines": totalMachines.value,
          "challenges-completed": _unref(userPublic).challenges_completed || 0,
          "total-challenges": totalChallenges.value,
          "streak-current": _unref(userPublic).login_streak_current ?? null,
          "rank-competitive-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.rank_competitive_label`),
          "rank-global-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.rank_global_label`),
          "first-blood-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.first_blood_label`),
          "machines-completed-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.machines_completed_label`),
          "challenges-completed-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.challenges_completed_label`),
          "streak-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.streak`),
          "global-suffix": _ctx.$t(`${_unref(currentLanguage)}.profile_public.global_suffix`),
          "conquests-suffix": _ctx.$t(`${_unref(currentLanguage)}.profile_public.conquests_suffix`),
          "labs-suffix": _ctx.$t(`${_unref(currentLanguage)}.profile_public.labs_suffix`),
          "challenges-suffix": _ctx.$t(`${_unref(currentLanguage)}.profile_public.challenges_suffix`),
          "days-suffix": _ctx.$t(`${_unref(currentLanguage)}.profile_public.days_suffix`)
        }, null, 8, ["scoreboard-position", "scoreboard-global-position", "total-first-bloods", "machines-completed", "total-machines", "challenges-completed", "total-challenges", "streak-current", "rank-competitive-label", "rank-global-label", "first-blood-label", "machines-completed-label", "challenges-completed-label", "streak-label", "global-suffix", "conquests-suffix", "labs-suffix", "challenges-suffix", "days-suffix"]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(CertificationsBadgeRow, {
            certifications: _unref(certifications),
            title: _ctx.$t(`${_unref(currentLanguage)}.profile_public.certifications_title`),
            "empty-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.no_certifications_yet`),
            "current-language": _unref(currentLanguage)
          }, null, 8, ["certifications", "title", "empty-label", "current-language"]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("h4", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.badges`)), 1)
              ]),
              (_unref(ownedBadges).length)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'public-badges', params: { id: _unref($route).params.id } },
                    class: "see-all-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.see_all`)), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            (_unref(ownedBadges).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ownedBadges), (badge, idx) => {
                    return (_openBlock(), _createBlock(CardBadge, {
                      key: badge?.id ?? badge?.badge_id ?? idx,
                      badge: badge
                    }, null, 8, ["badge"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.no_badges_yet`)), 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h4", _hoisted_47, [
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.course_certificates_title`)), 1)
              ])
            ]),
            _createVNode(_unref(Carousel), {
              class: "py-2",
              autoplay: 5000,
              "items-to-show": 1.8,
              "wrap-around": true
            }, {
              addons: _withCtx(() => [
                _createVNode(_unref(Navigation))
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(certificates), (certificate, name) => {
                  return (_openBlock(), _createBlock(_unref(Slide), { key: name }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(CourseCertificateHexagon, {
                          certificate: certificate,
                          "locked-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.certificate_locked`)
                        }, null, 8, ["certificate", "locked-label"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["items-to-show"])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", null, [
                _createVNode(AbilitiesRadarGraphic, {
                  "categories-data": radarCategories.value,
                  "all-categories-data": radarAllCategories.value,
                  "selected-category-ids": radarSelectedCategoryIds.value,
                  "current-language": _unref(currentLanguage),
                  filtering: radarFiltering.value,
                  loading: loading.value,
                  "loading-label": _unref(t)(`${_unref(currentLanguage)}.common.loading`),
                  "onUpdate:selectedCategoryIds": _cache[0] || (_cache[0] = ($event: any) => (radarSelectedCategoryIds.value = $event)),
                  onApplyFilter: handlePublicRadarApplyFilter
                }, null, 8, ["categories-data", "all-categories-data", "selected-category-ids", "current-language", "filtering", "loading", "loading-label"])
              ])
            ])
          ]),
          _createVNode(ActivityHeatmap, {
            timeline: _unref(userPublic).timeline || [],
            title: _ctx.$t(`${_unref(currentLanguage)}.profile_public.activity_heatmap_title`),
            "less-active-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.less_active`),
            "more-active-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.more_active`)
          }, null, 8, ["timeline", "title", "less-active-label", "more-active-label"]),
          _createVNode(RecentActivityList, {
            timeline: (_unref(userPublic).timeline || []).slice(0, 8),
            title: _ctx.$t(`${_unref(currentLanguage)}.profile_public.recent_activity_title`),
            "empty-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.no_recent_activity`),
            "lesson-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.finished_lesson`),
            "challenge-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.finished_challenge`),
            "machine-label": _ctx.$t(`${_unref(currentLanguage)}.profile_public.finished_machine`)
          }, null, 8, ["timeline", "title", "empty-label", "lesson-label", "challenge-label", "machine-label"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
        ])
      ]))
}
}

})